import { Experiment } from '@ms/yammer-data/dist/state/ecsExperiments/types';

import { useAndReportExperimentTreatment } from '../experiments';
import { useFeatureAccessSettings } from '../featureAccessSettings';
import { useStorylineSettings } from '../storylineSettings';

type UseCanCurrentUserAccessStoryline = () => boolean;
export const useCanCurrentUserAccessStoryline: UseCanCurrentUserAccessStoryline = () => {
  const featureAccessSettings = useFeatureAccessSettings();
  const storylineSettings = useStorylineSettings();
  const isStorylineBootstrapNetworkCallEnabled =
    useAndReportExperimentTreatment(Experiment.StorylineBootstrapNetworkCall) === 'enabled';

  if (isStorylineBootstrapNetworkCallEnabled) {
    return !!storylineSettings?.viewerCanAccessStoryline;
  }

  return !!featureAccessSettings?.viewerCanAccessStoryline;
};
